import React from 'react';
import { connect, useSelector } from 'react-redux'
import { useState, useMemo, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import CardHeader from '../../../containers/CardHeader'
import Form from '../../../containers/Form/Form'
import Select from "../../../containers/Form/Select";

import Moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_cascade_metrics } from "../../../app/apiEndpoints" //tool_lp_dashboard_boost
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, FormGroup, FormLabel, Breadcrumb } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'

//import { CSVLink } from "react-csv";
import CascadeToolToggle from '../../../containers/CascadeToolToggle';


const CascadeMetricsTool = (props) => {
    const toolID = 27
    const [tool, setTool] = useState({})

    const [cascadeType, setCascadeType] = useState(0)

    //const [hasErrors, setHasErrors] = useState(false)
    //const [status, setStatus] = useState(0)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [stats, setStats] = useState([])
    const [pids, setPids] = useState([])
    const [geos, setGeos] = useState([])

    //filters
    const [startDate, setStartDate] = useState(new Date(Moment().add(-1, 'days').format('MM/DD/YYYY')))
    const [endDate, setEndDate] = useState(new Date(Moment().format('MM/DD/YYYY')))
    const [curPid, setCurPid] = useState('')
    const [curGeo, setCurGeo] = useState('')
    const [curDevice, setCurDevice] = useState('')
    
    const tableFields = ["Date", "Page Hits", "Form Starts", "Questions Checked", "Form Submits", "Accepted Leads", "Rejected Leads", "Avg Rev Per Lead"]
    const tableFieldName = ["report_date", "page_hits", "form_starts", "questions_analyzed", "form_submits", "accepted_leads", "rejected_leads", "avg_rev_per_lead"]

    const [sortField, setSortField] = useState('total_requests')
    const [sortDirection, setSortDirection] = useState(1)

    //const boostFields = ["Path", "Subpid", "End Date"]
    //const successFields = ["Path", "Success #", "Total #", "Success %"]

    // const [revCsvStatus, setRevCsvStatus] = useState(0)
    // const [revCsv, setRevCsv] = useState({})

    // const [regCsvStatus, setRegCsvStatus] = useState(0)
    // const [regCsv, setRegCsv] = useState({})

    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getStats = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_cascade_metrics, { 'requester': userID, 'company': companyID, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
                setStats(data.stats)
                if(data.pids) setPids(data.pids)
                if(data.geos) setGeos(data.geos)
            }
        }
            getStats()
    }, [userID, companyID, curPid, curGeo, curDevice, startDate, endDate, cascadeType])

    // const genRevReport = async (e) => {
    //     e.preventDefault()
    //     setRevCsvStatus(1)
    //     const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 1, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
    //     if(csvData.revcsv) { 
    //         setRevCsv(csvData.revcsv)
    //         setRevCsvStatus(2)
    //     }
    // }

    // const genRegReport = async (e) => {
    //     e.preventDefault()
    //     setRegCsvStatus(1)
    //     const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 2, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
    //     if(csvData.revcsv) { 
    //         setRegCsv(csvData.revcsv)
    //         setRegCsvStatus(2)
    //     }
    // }

    const tableData = (type) => {
        let values = stats

        // Sort values before mapping
        values = [...values].sort((a, b) => {
            // Always move "TOTAL" to the bottom
            if (a.path === "TOTAL") return 1;
            if (b.path === "TOTAL") return -1;

            let aValue = a[sortField];
            let bValue = b[sortField];

            // Convert to number if field is numeric
            if (['page_hits','form_starts','questions_analyzed','form_submits','accepted_leads','rejected_leads'].includes(sortField)) {
                aValue = parseInt(aValue);
                bValue = parseInt(bValue);
            } else if (['avg_rev_per_lead'].includes(sortField)) {
                aValue = parseFloat(aValue);
                bValue = parseFloat(bValue);
            } else {
                aValue = String(aValue).toLowerCase();
                bValue = String(bValue).toLowerCase();
            }

            if (aValue < bValue) return sortDirection === 0 ? -1 : 1;
            if (aValue > bValue) return sortDirection === 0 ? 1 : -1;
            return 0;
        });

        let rows = [];
        values.forEach(row => {
            rows.push({'id': row.report_date, 'values': [
                row.report_date,
                row.page_hits,
                row.form_starts,
                row.questions_analyzed,
                row.form_submits,
                row.accepted_leads,
                row.rejected_leads,
                row.avg_rev_per_lead ? '$' + parseFloat(row.avg_rev_per_lead).toFixed(4) : ''
            ]});
        });
        return rows
    }

    const sortData = (field, direction) => {
        let index = tableFields.indexOf(field)

        setSortField(tableFieldName[index])
        setSortDirection(direction)
    }


    const filterCascade = (e) => {
        let { value } = e.target;
        setStats([])
        setCascadeType(value)
    }
    const filterPid = (e) => {
        let { value } = e.target;
        setStats([])
        setCurPid(value)
    }
    const filterGeo = (e) => {
        let { value } = e.target;
        setStats([])
        setCurGeo(value)
    }
    const filterDevice = (e) => {
        let { value } = e.target;
        setStats([])
        setCurDevice(value)
    }

    if(!tool) return <></>

    if(!pids) return <>No Data</>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
            <Card>
            <CascadeToolToggle title={tool.tool_name} description={tool.description} value={cascadeType} onChange={filterCascade} />
                <Form description={tool.description} noCard={true} >
                    <Row>
                        <Col md={6}>
                            <strong>Dates</strong>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={startDate}>Start Date</FormLabel>
                                <Col md={6}>
                                    <DatePicker id="startDate" name="startDate" selected={startDate} className="form-control" onChange={(date) => setStartDate(date)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={endDate}>End Date</FormLabel>
                                <Col md={6}>
                                <DatePicker id="endDate" name="endDate" selected={endDate} className="form-control" onChange={(date) => setEndDate(date)} />
                                </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <strong>Filters</strong>
                    {pids.length === 0 ? "" :
                    <Select
                        value={curPid}
                        label="SUBPID"
                        name="pid"
                        formValues={pids}
                        useDefault={false}
                        onChange={filterPid}
                        validate="string"
                        colSize="6"
                    />}
                    {geos.length === 0 ? "" :
                    <Select
                        value={curGeo}
                        label="GEOS"
                        name="geo"
                        formValues={geos}
                        useDefault={false}
                        onChange={filterGeo}
                        validate="string"
                        colSize="6"
                    />}
                    <Select
                        value={curDevice}
                        label="DEVICES"
                        name="device"
                        formValues={[{'ID': "", 'NAME': "VIEW ALL DEVICES"}, {'ID': "mobile", 'NAME': "Mobile"}, {'ID': "desktop", 'NAME': "Desktop"}]}
                        useDefault={false}
                        onChange={filterDevice}
                        validate="string"
                        colSize="6"
                    />
                    </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                        <CardHeader title="Cascade Metrics by Day" description="Full data started tracking on 2025-11-25 and will be incomplete prior to this date." />
                        <DataTable hover={false} tableID="metric" fieldNames={tableFields} dataRows={tableData(1)} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Day' />
                        
                        {/* <p align="center">
                        { revCsvStatus === 0 && // default
                            <Button title="Generate Revenue Report" className="secondary" onClick={genRevReport} /> }
                        { revCsvStatus === 1 && // generating has begun
                            <small>Generating Report...</small> }
                        { revCsvStatus === 2 && revCsv.file && // download now available
                        <CSVLink 
                        data={revCsv.data}
                        filename={revCsv.file}
                        className="btn btn-primary text-center"
                        target="_blank">Export Revenue Data</CSVLink>}

                        { regCsvStatus === 0 && // default
                            <Button title="Generate RegData Report" className="secondary" onClick={genRegReport} /> }
                        { regCsvStatus === 1 && // generating has begun
                            <small>Generating Report...</small> }
                        { regCsvStatus === 2 && regCsv.file && // download now available
                        <CSVLink 
                        data={regCsv.data}
                        filename={regCsv.file}
                        className="btn btn-primary text-center ml-2"
                        target="_blank">Export RegData</CSVLink>}  
                        </p> */}
                        </Col>
                    </Row>
                </Form>
                </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(CascadeMetricsTool), "Cascade Metrics Dashboard"));